import React, { useEffect, useRef } from 'react';
import './Features.css';

const featuresData = [
  {
    icon: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=100&q=80',
    title: '手工拉面',
    description: '24遍拉伸，8秒成型'
  },
  {
    icon: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=100&q=80',
    title: '新鲜食材',
    description: '每日清晨采购'
  },
  {
    icon: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=100&q=80',
    title: '慢火熬汤',
    description: '12小时骨汤'
  },
  {
    icon: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=100&q=80',
    title: '大师传承',
    description: '三代匠人技艺'
  }
];

const Features = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (sectionRef.current) {
      const items = sectionRef.current.querySelectorAll('.feature-item');
      items.forEach((item, index) => {
        item.style.opacity = '0';
        item.style.transform = 'translateY(30px)';
        item.style.transition = `all 0.6s ease ${index * 0.1}s`;
        observer.observe(item);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="features" ref={sectionRef}>
      <div className="features-bg">
        <img src="https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=1920&q=80" alt="特色" />
      </div>
      <div className="container">
        <div className="feature-grid">
          {featuresData.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                <img src={feature.icon} alt={feature.title} />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
